import { themeConfig } from "@/lib/theme-config"

export default function StepSkeleton() {
  return (
    <div
      className="border border-gray-200 rounded-md p-4 animate-pulse"
      style={{ 
        backgroundColor: `${themeConfig.colors.primary}05`,
        minHeight: '120px', // Match the actual step height
        transition: 'all 0.3s ease-in-out'
      }}
    >
      <div className="h-5 w-3/4 bg-gray-200 rounded mb-3"></div>
      <div>
        <div className="h-4 w-1/3 bg-gray-200 rounded mb-2"></div>
        <div className="flex flex-wrap gap-2 mt-1 min-h-[32px]">
          <div className="h-6 w-24 rounded-full" style={{ backgroundColor: `${themeConfig.colors.primary}40` }}></div>
          <div className="h-6 w-20 rounded-full" style={{ backgroundColor: `${themeConfig.colors.primary}40` }}></div>
          <div className="h-6 w-28 rounded-full" style={{ backgroundColor: `${themeConfig.colors.primary}40` }}></div>
        </div>
      </div>
    </div>
  )
}
